import { useMemo } from 'react'
import { useMotionEnabled } from '../../hooks/useMotionEnabled'

export function StdoutStream({ enabled = true }: { enabled?: boolean }) {
  const motion = useMotionEnabled()
  const lines = useMemo(() => {
    const verbs = ['POST', 'INGEST', 'INDEX', 'ROUTE', 'JOIN', 'SIGN', 'EMIT']
    const grids = ['au-housing', 'rba-rates', 'q2-revenue', 'agent-mem', 'climate-au', 'asx-tick', 'orders', 'sensors', 'logs', 'sales-eu']
    const out: string[] = []
    for (let i = 0; i < 40; i++) {
      const v = verbs[i % verbs.length]
      const g = grids[(i * 3) % grids.length]
      const ms = (10 + ((i * 17) % 90)).toString().padStart(2, '0')
      const sz = (1 + (i * 11) % 99) * 100
      const sha = Math.floor(((i * 1009) % 0xffff)).toString(16).padStart(4, '0')
      const status = i % 7 === 0 ? '202' : '200'
      out.push(`${v.padEnd(7)} /v1/${v === 'JOIN' ? 'mesh' : 'ingest'}/${g.padEnd(11)} ${status} ${ms.padStart(3)}ms +${sz.toString().padStart(4)} rows · sha:${sha}…`)
    }
    return out
  }, [])

  if (!enabled) return null
  return (
    <div aria-hidden="true" className="stdout-stream" style={{
      position: 'absolute', inset: 0, overflow: 'hidden', pointerEvents: 'none', zIndex: 0,
      maskImage: 'linear-gradient(to bottom, transparent 0%, black 18%, black 82%, transparent 100%)',
      WebkitMaskImage: 'linear-gradient(to bottom, transparent 0%, black 18%, black 82%, transparent 100%)',
    }}>
      <div style={{
        position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column',
        fontFamily: 'var(--mono)', fontSize: 11, lineHeight: 1.85, color: 'var(--fg-3)', opacity: 0.33,
        whiteSpace: 'nowrap',
        animation: motion ? 'stdoutScroll 90s linear infinite' : 'none',
        paddingLeft: 24,
      }}>
        {[...lines, ...lines, ...lines].map((l, i) => (
          <span key={i} style={{
            color: i % 11 === 0 ? 'var(--accent)' : (i % 17 === 0 ? '#B79DFF' : i % 23 === 0 ? 'var(--lime)' : 'currentColor'),
            opacity: 0.9 - (i % 7) * 0.05,
          }}>{l}</span>
        ))}
      </div>
      <style>{`@keyframes stdoutScroll { 0% { transform: translateY(0); } 100% { transform: translateY(-33.333%); } }`}</style>
    </div>
  )
}
